// Evolve's default landing context. Normal customer switching remains available.
const key = userId => `ww-admin-start:${userId}`;
export function readAdminStart(userId) {
  try {
    const value = JSON.parse(localStorage.getItem(key(userId)));
    return Number.isSafeInteger(value?.customerId) && value.customerId > 0
      && (value.siteId === null || (Number.isSafeInteger(value.siteId) && value.siteId > 0)) ? value : null;
  } catch { return null; }
}
export function saveAdminStart(userId, value) {
  if (value) localStorage.setItem(key(userId), JSON.stringify(value));
  else localStorage.removeItem(key(userId));
}

export async function resolveAdminStart(api, userId, selectCustomer, clearCustomer) {
  let access;
  try { ({ data: access } = await api.get('/customers/access')); }
  catch { return { name: 'Customers' }; }
  if (!access.platformAdministrator)
    return access.ownCustomerId
      ? { name: 'CustomerDetails', params: { customerId: access.ownCustomerId } }
      : { name: 'Customers' };
  const preference = readAdminStart(userId);
  if (!preference) return { name: 'Customers' };
  const { customerId: defaultCustomerId } = preference;
  try {
    if (access.userId !== userId) return { name: 'Customers' };
    const { data } = await api.get(`/customers/${defaultCustomerId}`);
    if (data.customer?.customerId !== defaultCustomerId || !data.customer.active)
      return { name: 'Customers' };
    selectCustomer(userId, data.customer);
    return { name: 'CustomerDetails', params: { customerId: defaultCustomerId } };
  } catch {
    clearCustomer();
    return { name: 'Customers' };
  }
}
